import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
export default function withDelayHovering(WrappedComponent) {
  return function (props) {
    var _React$useState = React.useState(false),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        hovering = _React$useState2[0],
        setHovering = _React$useState2[1];

    var hoverTimeout = React.useRef();

    var onMouseOver = function onMouseOver() {
      if (!hovering) {
        clearTimeout(hoverTimeout.current);
        hoverTimeout.current = setTimeout(function () {
          setHovering(true);
        }, 300);
      }
    };

    var onMouseLeave = function onMouseLeave() {
      clearTimeout(hoverTimeout.current);
      setHovering(false);
    };

    return React.createElement("div", {
      onMouseOver: onMouseOver,
      onMouseLeave: onMouseLeave
    }, React.createElement(WrappedComponent, Object.assign({}, props, {
      hovering: hovering
    })));
  };
}